var render = function render(_c, _vm) {
  return _c(
    "label",
    {
      class: [_vm.$style.formLabel, _vm.props.small && _vm.$style.small],
      attrs: { for: _vm.props.for },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }